import { type FC } from 'react'
import styled from '@emotion/styled'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'
import IconWrapper from '@segment/matcha/components/IconWrapper'

import { Build2Icon, GraphIcon, ComputerIcon } from '@segment/matcha/components/Icons/Brandbook'

import FeatureBoxBase, * as FeatureBox from '@segment/matcha/components/FeatureBox'

import * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

const copy = {
  heading: `Why Segment`,
}

const data = [
  {
    icon: Build2Icon,
    heading: `Build your way, with the tools that best serve you`,
    description: `We’ve built an open, scalable platform that adapts to the software and tools you’ve chosen—not the other way around.`,
  },
  {
    icon: GraphIcon,
    heading: `Reliably handle enterprise-scale processing`,
    description: `Our architecture is trusted by the biggest companies in the world to process over a million API calls per second with 99.9999% (and even more decimal places!) uptime.`,
  },
  {
    icon: ComputerIcon,
    heading: `The sky’s the limit with our Developer Toolkit`,
    description: `Build custom integrations, enrich and transform data, and extend the power of Segment to fit your organization’s unique requirements.`,
  },
]

const WhySegment: FC = () => {
  return (
    <Wrapper>
      <StyledSection variant="centered">
        <Section.Copy>
          <CopyText.Heading variant="h2" tag="h2">
            {copy.heading}
          </CopyText.Heading>
        </Section.Copy>

        <Section.Contents>
          <ColumnsWrapper>
            <ColumnTrack columns={1} overrides={{ md: 3 }}>
              {data.map(({ icon: Icon, heading, description }) => (
                <FeatureBoxBase key={heading} headerPosition="top" alignment="left">
                  <FeatureBox.Header>
                    <StyledIconWrapper variant="circle" elevation={1}>
                      <Icon size="large" />
                    </StyledIconWrapper>
                  </FeatureBox.Header>
                  <FeatureBox.Body>
                    <FeatureBox.Title>{heading}</FeatureBox.Title>
                    <FeatureBox.Text>{description}</FeatureBox.Text>
                  </FeatureBox.Body>
                </FeatureBoxBase>
              ))}
            </ColumnTrack>
          </ColumnsWrapper>
        </Section.Contents>
      </StyledSection>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  background: ${({ theme }) => theme.palette.twilio.mint[10]};
`

const StyledSection = styled(SectionBase)`
  max-width: 1280px;

  ${Section.Wrapper} {
    gap: 0;
  }
`

const ColumnsWrapper = styled.div`
  margin-top: 30px;
`

const StyledIconWrapper = styled(IconWrapper)`
  width: 64px;
  height: 64px;
  padding: 6px;
`

export default WhySegment
